import { render, staticRenderFns } from "./AccountLogoutView.vue?vue&type=template&id=1b861b66&scoped=true&"
import script from "./AccountLogoutView.vue?vue&type=script&lang=js&"
export * from "./AccountLogoutView.vue?vue&type=script&lang=js&"
import style0 from "./AccountLogoutView.vue?vue&type=style&index=0&id=1b861b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b861b66",
  null
  
)

/* custom blocks */
import block0 from "./AccountLogoutView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports